import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needsEmailPrompt, setNeedsEmailPrompt] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithToken = (token, u, opts = {}) => {
    localStorage.setItem("sf_token", token);
    setUser(u);
    if (opts.needsEmail) setNeedsEmailPrompt(true);
  };

  const dismissEmailPrompt = () => setNeedsEmailPrompt(false);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed", e); }
    localStorage.removeItem("sf_token");
    setUser(null);
    setNeedsEmailPrompt(false);
  };

  const value = useMemo(
    () => ({ user, setUser, loading, loginWithToken, logout, checkAuth, needsEmailPrompt, dismissEmailPrompt }),
    [user, loading, needsEmailPrompt, checkAuth] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
